import {
    makeStyles,
} from 'app/tss'

const general = 'general'
const other = 'other'
const handover = 'handover'
const collection = 'collection'

const useStyles = makeStyles()((theme) => {
    return {
        formContainer: {
            cursor: 'auto',
            background: theme.palette.secondary[50],
        },
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(2),
            gridTemplateAreas: `
                "${general} ${other}"
                "${handover} ${collection}"
                `,
            gridTemplateColumns: 'repeat(2, 2fr)',
        },
        general: {
            gridArea: general,
            height: 'fit-content',
        },
        handover: {
            gridArea: handover,
        },
        collection: {
            gridArea: collection,
        },
        actionLink: {
            whiteSpace: 'nowrap',
        },
    }
})

export default useStyles
